export const verifyFields = [
  {
    label: "审批名称",
    value: "name"
  },
  {
    label: "发起人",
    value: "userName"
  },
  {
    label: "发起时间",
    value: "createAt"
  },
  {
    label: "审批人",
    value: "verifyUser"
  },
  {
    label: "审批时间",
    value: "finishAt"
  },
  {
    label: "审批结果",
    value: "result"
  },
  {
    label: "审批意见",
    value: "rejectReason"
  },
  {
    label: "审批签名",
    value: "sign"
  }
]
